import axios from 'axios';
import { isNil, forOwn } from 'lodash';
import AuthService  from './AuthService';

export default class ApiService {
    static async doGet(url, config) {
        let requestConfig = { headers: {} };
        if (!isNil(config)) {
            requestConfig = config;
        }
        requestConfig.headers = await this.computeRequestHeaders(config);

        return axios.get(`${url}`, requestConfig).then((resp) => {
            console.log('Received response from: ', url);
            return resp.data;
        })
            .catch((error) => {
                console.log(`Response to ${url} failed: `, error);
            });
    }

    static async doPost(url, params, additionalHeaders) {
        console.log(url);
        console.log(params);
        console.log(additionalHeaders);
        additionalHeaders = {};
        const requestConfig = {};
        requestConfig.headers = await this.computeRequestHeaders(additionalHeaders);
        console.log('params' + params);
        console.log(additionalHeaders);
        return axios.post(`${url}`, params, requestConfig).then((resp) => {
            console.log('Received response from: ', url);
            console.log('Resonse Data: ', resp.data.name);
            return resp.data;
        })
            .catch((error) => {
                // console.log(`Response to ${url} failed: `, error);
                console.log(error);
            });
    }

    static async doDelete(url, data, additionalHeaders) {
        const requestConfig = {};
        requestConfig.headers = await this.computeRequestHeaders(additionalHeaders);

        if (!isNil(data)) {
            requestConfig.data = data;
        }

        return axios.delete(`${url}`, requestConfig).then((resp) => {
            console.log('Received response from: ', url);
            return resp.data;
        })
            .catch((error) => {
                console.log(`Response to ${url} failed: `, error);
            });
    }

    static async computeRequestHeaders(config) {
        const loggedIn = !isNil(localStorage.getItem('admin'));
        const headers = {};
        if (loggedIn) {
            console.log('logged in');
            await AuthService.checkIfNewJWTRequired();
            headers.Authorization = `Bearer ${localStorage.getItem('admin')}`;
            console.log(localStorage.getItem('admin'));
        }

        if (!isNil(config)) {
            forOwn(config, (value, key) => {
                headers[key] = value;
            });
        }
        console.log(config);

        return headers;
    }
}
